import { useMemo } from 'react';

import BannerContext from 'contexts/BannerContext';

import type { ComponentWithChildren } from '@polyai/common/types/helpers';

import { useOTTrialBanner } from './banners/OTTrialBanner';
import { useTrialBanner } from './banners/TrialBanner';

/**
 * Banner component that displays various system-wide banners.
 * Only one banner will be shown at a time based on priority order.
 */
export const Banner: ComponentWithChildren = ({ children }) => {
  const bannerRenderers = [useTrialBanner(), useOTTrialBanner()];

  // Find the first banner that should render (non-null means it should render)
  const activeBannerRenderer = bannerRenderers.find(config => config !== null);
  const isBannerShown = activeBannerRenderer !== undefined;

  const contextValue = useMemo(() => ({ isBannerShown }), [isBannerShown]);

  return (
    <BannerContext.Provider value={contextValue}>
      {activeBannerRenderer?.()}
      {children}
    </BannerContext.Provider>
  );
};

export default Banner;
